import { DataContext } from "@/types";
import { Data } from "../Data";
import { User } from "../users/User";

// @ts-expect-error - static get() intentionally overrides base class return type
export class EmployeeSelectorList extends Data {
  static instance: any = null;
  employees: any;
  attributes: any;

  constructor(options: any) {
    super({
      api: "/Employee/Search?searchText=" + options.search,
      callback: (data: any) => {
        options.resolve(this, false);
      },
      ...options
    });
  }

  onDataReceived(data: any) {
    this.employees = [];
    data.employees.forEach((employee: any, index: any) =>
      this.employees.push(new User({ data: { id: index, ...employee } }))
    );
  }

  static getEmployeeSelectorList(
    context: DataContext,
    search: string
  ): Promise<EmployeeSelectorList> {
    return new Promise((resolve, reject) => {
      if (EmployeeSelectorList.instance && search === "") resolve(EmployeeSelectorList.instance);
      else
        EmployeeSelectorList.instance = new EmployeeSelectorList({
          resolve,
          reject,
          search,
          context
        });
    });
  }

  static get(context: DataContext, search: string | null): Promise<EmployeeSelectorList> {
    return EmployeeSelectorList.getEmployeeSelectorList(context, search ?? "");
  }

  findMatch(attr: any) {
    return this.attributes.find((a: any) => a.name === attr);
  }
}
